  /* eslint-disable */
  <template >
  <div v-role="'func'">
      <br><br>
            <v-card style="margin:auto;" width="900px">

              <template >

                  <v-toolbar  color="grey lighten-2">

             <v-row>
                    <v-col sm="4" cols="12" md="4">

              <v-btn v-if="novo"  color="primary" size="10" fab   @click="novo= PEditar =  false"><v-icon large   >clear</v-icon></v-btn>
              <v-btn v-if="!novo"  color="primary" size="10" fab   @click="editar()"><v-icon large   >edit</v-icon></v-btn>

                  </v-col>

                  <v-col sm="4" cols="12" md="6">  <!--  form titlte section   {{ formTitle }}-->
                <span> Cadastro de contas</span>

                  </v-col>

                    <v-col sm="4"  cols="12" md="2">
                      <v-btn size="18"    fab dark color="success"  @click="Novo()">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                  </v-col>

          </v-row>

                </v-toolbar>

              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                   <v-row>

                    <v-col cols="12" md="12">
                      <v-combobox v-if="novo"
                        :rules="ruleRequired"
                        v-model="bancoSelected"
                        :items="bancos"
                        item-value="pk_banco"
                        item-text="nome"
                        chips
                        label="Selecione a instituição bancária"
                      ></v-combobox>
                      <v-text-field v-if="!novo"
                        v-model="this.editedItem.nome"
                        :disabled="true"
                        label="Descrição do banco"
                        readonly
                    ></v-text-field>
                    </v-col>

                  <v-col cols="12" md="12">
                      <v-text-field v-if="novo"
                        v-model="preco"
                        :rules="ruleRequired"
                        label="Forneça o número da conta">
                       </v-text-field>
                       <v-text-field v-if="!novo"
                       v-model="editedItem.numero_conta"
                       :disabled="true"
                        label="Número do banco"
                        readonly
                    ></v-text-field>
                   </v-col>

 </v-row>
 <v-row>
   <v-col cols="12" md="5">
   </v-col>
   <v-col cols="12" md="6" v-if="progresso">
       <v-progress-circular
                    :size="50"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
   </v-col>
 </v-row>
 <v-row>
   <v-col md="4"></v-col>
   <v-col md="4"></v-col>
  <v-col md="2"><!--<v-btn fab   color="success"      @click="close"><v-icon large >edit</v-icon></v-btn>-->
  </v-col>
   <v-col md="2">
      <v-btn    :disabled="!valid || !novo"  fab        color="success"    @click="save"><v-icon large   >send</v-icon></v-btn>

   </v-col>
 </v-row>

                </v-container>
              </v-card-text>

</v-form>

            </v-card>

</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],

    PEditar: false,
    progresso: false,
    bancos: [],
    novo: false,
    contas: [],
    banco: '',
    numeroConta: '',
    contasExistentes: [],
    bancoSelected: '',
    preco: '',
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    multas: ['Acumuladas', 'Transitiva'],
    menubi: false,
    ano_actual: (new Date().getFullYear()),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],

    searchInDb: '',
    estudantes: [],
    dialog: false,
    idd: false, // simula autoinclemet
    classes: ['10ª Classe', '11ª Classe', '12ª Classe'],
    servicos: ['Matricula', 'Confirmação de Matricula', 'Propina', 'Certificado', 'Declaração com nota', 'Declaração sem notas'],
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Número da conta',
        align: 'left',
        sortable: false,
        value: 'conta'
      },

      { text: 'Banco', value: 'banco' },
      { text: 'data_de_cadastro', value: 'data' },
      { text: 'Autor', value: 'autor' }
    ],

    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,

    editedItem: {
      autor: '',
      data_cadastro: '',
      fk_banco: 0,
      instituicao: 0,
      nome: '',
      numero_conta: '',
      pk_banco: 0,
      pk_conta_bancaria: 0,
      status_banco: 0,
      status_conta_bancaria: 0
    }

  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
    this.initializeContasBancarias()
  },

  methods: {
    async initialize (searchInDb) {
      try {
        this.isLoading = true
        this.bancos = await axios
          .get('/bancoFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo

    async initializeContasBancarias () {
      try {
        this.isLoading = true
        this.contasExistentes = await axios
          .get('/conta-bancariaFindAll')
          .then(res => res.data)
        console.log(this.contasExistentes)

        if (this.contasExistentes.length) {
          this.editedItem = Object.assign({}, this.contasExistentes[0])
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    // METHODO FOR VALIDATI
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = ''
        this.descricao = 'Nº do Bi'
        this.mascara = '#########-AA-###'
        this.ruleBI =
        [
          value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'
        ]
      } else {
        this.editedItem.bi = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
        [
          // eslint-disable-next-line no-mixed-operators
          value => value.length >= 16 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'
        ]
      }
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    chamaDialogo () {
      this.dialog = true
    },

    editar () {
      this.bancoSelected = this.editedItem.nome
      this.preco = this.editedItem.numero_conta
      this.novo = true
      this.PEditar = true

      console.log(this.editedItem)
    },
    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
        console.log(this.$store.state.actividades)
      } catch (error) {

      }
    },

    Novo () {
      this.novo = true
      this.bancoSelected = ''
      this.preco = ''
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount

      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)
        this.isLoading = false
        console.log(this.turmasFiltered)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    editItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      this.dialog = true
    },

    deleteItem (item) {
      const index = this.estudantes.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.delete(item.pkPessoa)
      // this.estudantes.splice(index, 1)
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(date).toISOString().substr(0, 10)
    },
    async save () {
      if (this.$refs.form.validate()) {
        var params =
          {
            pk_conta_bancaria: 0,
            banco: this.bancoSelected.pk_banco,
            conta: this.preco
          }

        if (this.PEditar) {
          params =
          {
            pk_conta_bancaria: this.editedItem.pk_conta_bancaria,
            banco: (this.bancoSelected.pk_banco === undefined) ? this.editedItem.fk_banco : this.bancoSelected.pk_banco,
            conta: this.preco
          }
        }

        try {
          this.progresso = true
          let corMensagem = 'msgError'
          let msg = await axios
            .post('/bancoInsertOrUpdate', params)
            .then(res => res.data)
          this.progresso = false

          if (msg.length) {
            corMensagem = 'msgError'
            this.text = 'Ocorreu um erro ao tentar efectuar a operação'
          } else {
            corMensagem = 'msgSucess'
            this.text = 'Número de conta cadastrada com sucesso'
            this.novo = false
            this.initializeContasBancarias()
          }

          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 5000 })
          this.Limpar()
        } catch (error) {
          this.progresso = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    Limpar () {
      this.bancoSelected = ''
      this.preco = ''
    },

    async delete (idv) {
      try {
        var msg = await axios
          .get('/estudanteDeleteById/' + idv)
          .then(res => res.data)
        this.text = 'Deleted ' + msg.message

        this.initialize()

        this.close()
      } catch (error) {
        console.log('eroooo: ' + error)
        this.text = error.message
      } finally {

      }
    }
  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
